import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment.local';

@Injectable({
  providedIn: 'root',
})
export class TimelineSubscriptionsApi {
  constructor(private readonly http: HttpClient) { }

  getTimelineSubscriptionInformation(): Observable<any> {
    const url = environment.api.dashboard.timelineSubscriptions;
    return this.http.get<any>(url);
    // return of({
    //   sub: {
    //     endDate: null,
    //     endDateUnixTimestamp: null
    //   },
    //   trial: {
    //       endDate: '2022-12-27',
    //       endDateUnixTimestamp: '1672155670'
    //   },
    //   trial_period: 1,
    //   apple_in_app: {
    //       endDate: null,
    //       endDateUnixTimestamp: null,
    //       type: null
    //   },
    //   android_in_app: {
    //       endDate: null,
    //       endDateUnixTimestamp: null
    //   },
    //   isVipManufacturer: false,
    //   freemium: false,
    // });
  }
}
